import moment from 'moment';
import React, { useEffect } from 'react';
import TextBody from '../../../../../../components/controls/Typography/TextBody';
import { DelegateModalAlterStateInvoker } from '../DelegateModalAlterState/DelegateModalAlterState';
import { DelegateModalDeleteInvoker } from '../DelegateModalDelete/DelegateModalDelete';
import { DelegateModalEditInvoker } from '../DelegateModalEdit/DelegatesModalEdit';

import './DelegateListItem.less';

const ADDED_ITEMS_SET = new Set();

const isItemWasSeen = (/** @type {string|number} */ id) => {
  // use local storage to store the seen items
  const seenItems = localStorage.getItem('LSN_LP_CHECKS');
  if (seenItems) {
    const seenItemsSet = new Set(JSON.parse(seenItems));
    return seenItemsSet.has(id);
  }
  return false;
}

const markItemAsSeen = (/** @type {string|number} */ id) => {
  ADDED_ITEMS_SET.add(id);
  // use local storage to store the seen items
  localStorage.setItem('LSN_LP_CHECKS', JSON.stringify([...ADDED_ITEMS_SET]));
}

/**
 *
 * @param {{
 *  delegate: import('../../../../../../store/reducers/delegatesReducer').TDelegateListItem;
 *  onChanged?():void;
 * }} props
 * @returns
 */
export const DelegateListItem = (props) => {
  const { delegate, onChanged } = props;
  const itemRef = React.createRef();

  useEffect(() => {
    if (itemRef.current && !isItemWasSeen(delegate.id)) {
      markItemAsSeen(delegate.id);
      // animate the item
      const el = itemRef.current;
      itemRef.current.style.overflow = "hidden";
      itemRef.current.animate([
        {
          height: "0px",
          opacity: 0,
        },
        {
          height: `${itemRef.current.scrollHeight}px`,
          opcity: 1,
        },
      ], {
        duration: 400,
      })
        .addEventListener("finish", () => {
          el.style.overflow = "";
        });
    }
  }, [itemRef.current]);

  return (
    <div className={`lsn-delegate-list-item`} id={`delegate_${delegate.id}`} ref={itemRef} data-status={delegate.enabled ? 'active' : 'inactive'}>
      <div className="delegate-heading">
        <div className="delegate-full-name">
          <TextBody bold larger>{delegate.firstName} {delegate.lastName}</TextBody>
          {delegate.enabled ? null :
            <>
              <TextBody dangerouslySetInnerHTML={{ __html: '&ndash;' }}></TextBody>
              <TextBody bold>Deactivated</TextBody>
            </>}
        </div>
        <div className="delegate-actions">
          <DelegateModalEditInvoker delegate={delegate} onSuccess={onChanged} />
          <DelegateModalAlterStateInvoker delegate={delegate} onSuccess={onChanged} />
          <DelegateModalDeleteInvoker delegate={delegate} onSuccess={onChanged} />
        </div>
      </div>
      <div className="delegate-details">
        <ul className="list">
          <li>
            <TextBody bold>Delegate Email: </TextBody>
            <TextBody>
              <a tabIndex={0} className="shrink-email" href={'mailto:' + delegate.emailAddress}>
                {delegate.emailAddress}
              </a>
            </TextBody>
          </li>
          <li>
            <TextBody bold>Added On: </TextBody>
            <TextBody>{moment(delegate.createdDate).format('MMM DD, YYYY')}</TextBody>
          </li>
        </ul>
      </div>
    </div>
  );
}
